module.exports = __webpack_public_path__ + "_assets/img/home-a.2a4c0a26.svg";